import { render, staticRenderFns } from "./NewWorker.vue?vue&type=template&id=5a07b5d0&"
import script from "./NewWorker.vue?vue&type=script&lang=ts&"
export * from "./NewWorker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports